import React from 'react';
import Chart from 'react-apexcharts';
import get from 'lodash/get';
import { Map } from 'immutable';
import TargetBox from '../WeeklyTargets/TargetBox';
import { withStyles } from '@material-ui/core/styles';
import { TYPE_COLORS_BY_KEY } from '../../common/constants';
import Color from 'color';

const styles = theme => ({
  info: {
    width: 500,
  },
  values: {
    display: 'inline-block',
    width: 240,
    '& > *': {
      marginBottom: 5,
    },
  },
});

const CHART_RING_INFO = {
  'Weekly Upt': {
    color: TYPE_COLORS_BY_KEY.upt.bgColor,
  },
  'Weekly GP': {
    color: TYPE_COLORS_BY_KEY.gp.bgColor,
  },
  'Hourly Customers': {
    color: TYPE_COLORS_BY_KEY.hc.bgColor,
  },
};

export default withStyles(styles)(function TargetResultGauge(props) {
  const { periodPlanResults = [], classes } = props;
  const [stateMap, setState] = React.useState(Map({}));
  const state = React.useMemo(() => stateMap.toJS(), [stateMap]);
  const [stateInfoMap, setStateInfo] = React.useState(Map({}));
  const stateInfo = React.useMemo(() => stateInfoMap.toJS(), [stateInfoMap]);

  React.useEffect(() => {
    let totalPlanResults = periodPlanResults.length,
      totalHourlyCustomersPct = 0,
      totalWeeklyGpPct = 0,
      totalWeeklyUptPct = 0,
      totalHourlyCustomersActual = 0,
      totalWeeklyGpActual = 0,
      totalWeeklyUptActual = 0,
      totalHourlyCustomersTarget = 0,
      totalWeeklyGpTarget = 0,
      totalWeeklyUptTarget = 0;

    periodPlanResults.map(ppr => {
      if (!ppr) return;
      // totalHourlyCustomersPct += computePercentage(
      //   ppr.actualHourLyCustomers,
      //   ppr.targetHourLyCustomers,
      // );
      totalHourlyCustomersActual += ppr.actualHourLyCustomers;
      totalHourlyCustomersTarget += ppr.targetHourLyCustomers;
      // totalWeeklyGpPct += computePercentage(ppr.actualWeeklyGp, ppr.targetWeeklyGp);
      totalWeeklyGpActual += ppr.actualWeeklyGp;
      totalWeeklyGpTarget += ppr.targetWeeklyGp;
      // totalWeeklyUptPct += computePercentage(ppr.actualWeeklyUpt, ppr.targetWeeklyUpt);
      totalWeeklyUptActual += ppr.actualWeeklyUpt;
      totalWeeklyUptTarget += ppr.targetWeeklyUpt;
    });

    totalHourlyCustomersPct =
      (totalHourlyCustomersActual / totalHourlyCustomersTarget) * 100;
    totalWeeklyGpPct = (totalWeeklyGpActual / totalWeeklyGpTarget) * 100;
    totalWeeklyUptPct = (totalWeeklyUptActual / totalWeeklyUptTarget) * 100;

    setStateInfo(oldStateInfo =>
      oldStateInfo.merge({
        actual: {
          'Hourly Customers': totalHourlyCustomersActual,
          GP$: totalWeeklyGpActual,
          UPT: totalWeeklyUptActual / totalPlanResults,
        },
        target: {
          'Hourly Customers': totalHourlyCustomersTarget,
          GP$: totalWeeklyGpTarget,
          UPT: totalWeeklyUptTarget / totalPlanResults,
        },
      }),
    );
    setState(oldState =>
      oldState.merge({
        'Weekly Upt': totalWeeklyUptPct,
        'Weekly GP': totalWeeklyGpPct,
        'Hourly Customers': totalHourlyCustomersPct,
      }),
    );
  }, [periodPlanResults]);

  const { chartRingLabels, chartRingColors, chartRingValues } = React.useMemo(() => {
    const chartRingLabels = Object.keys(state);
    const chartRingValues = Object.values(state); //entries?
    return {
      chartRingLabels,
      chartRingColors: chartRingLabels.map(lbl => {
        return Color(CHART_RING_INFO[lbl].color).hex();
      }),
      chartRingValues,
    };
  }, [state]);
  return (
    <div>
      <Chart
        options={{
          labels: chartRingLabels,
          colors: chartRingColors,
          stroke: {
            lineCap: 'round',
          },
          plotOptions: {
            radialBar: {
              dataLabels: {
                showOn: 'always',
                value: {
                  formatter(val) {
                    console.log('>>TargetResultGauge/index::', 'val', val); //TRACE
                    return Number(val).toFixed(1) + '%';
                  },
                },
                total: {
                  show: true,
                  label: 'TOTAL',
                  formatter: function(w) {
                    // console.log('>>TargetResultGauge/index::', 'w', w); //TRACE
                    const total =
                      Number(
                        w.globals.seriesTotals.reduce((a, b) => {
                          return a + b;
                        }, 0) / w.globals.series.length,
                      ).toFixed(1) + '%';
                    return total;
                  },
                },
              },
            },
          },
        }}
        series={chartRingValues}
        type="radialBar"
        height="280"
      />
      <div className={classes.info}>
        <div className={classes.values}>
          <span>Target</span>
          {Object.entries(get(stateInfo, 'target', {})).map(([key, value]) => {
            return <TargetBox key={key} label={key} value={`$${value}`} />;
          })}
        </div>
        <div className={classes.values}>
          <span>Actual</span>
          {Object.entries(get(stateInfo, 'actual', {})).map(([key, value]) => {
            return <TargetBox key={key} lighten label={key} value={`$${value}`} />;
          })}
        </div>
      </div>
    </div>
  );
});
